export const animationDurationDefault = '300ms';
export const animationDurationShort = '200ms';
